import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { getAppProfileId } from './updateApisStatus'

const createApiMappingBody = (apiIdList: any[], producerChannelId: string, consumerChannelId: string) => {
  return {
    createApiMappingRequestList: [
      {
        producerChannelId: producerChannelId,
        consumerChannelId: consumerChannelId,
        apiIdList: apiIdList,
      },
    ],
  }
}
const responseParser = (data: any) => {
  return data
}

const createApiMappingReq = (apiList: any[], producerChannelId: string, consumerChannelId: string, tokens: any) => {
  const apiIdsList = apiList.map((api) => api.apiId)
  console.log('apiList, apiIdsList', apiList, apiIdsList)
  const request: Request<{}> = {
    apiPath: APIEndPoints.createApiMapping,
    method: 'POST',
    config: sitConfig(tokens),
    body: createApiMappingBody(apiIdsList, producerChannelId, consumerChannelId),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

const createApiMappingByProfileBody = (producerChannelId: string, consumerChannelId: string, profileName: string) => {
  return {
    createApiMappingRequestList: [
      {
        producerChannelId: producerChannelId,
        consumerChannelId: consumerChannelId,
        appProfileId: getAppProfileId(profileName),
      },
    ],
  }
}

const createApiMappingByProfileNameReq = (
  producerChannelId: string,
  consumerChannelId: string,
  profileName: string,
  tokens: any,
) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.createApiMapping,
    method: 'POST',
    config: sitConfig(tokens),
    body: createApiMappingByProfileBody(producerChannelId, consumerChannelId, profileName),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { createApiMappingReq, createApiMappingByProfileNameReq }
